export default __webpack_public_path__ + "static/media/Titans.43b98b48.png";